module.exports = __webpack_public_path__ + "img/angst_1600.2b724ed4.jpg";